import { render, staticRenderFns } from "./SituacionLaboralCombobox.vue?vue&type=template&id=6f2fde28&scoped=true"
import script from "./SituacionLaboralCombobox.vue?vue&type=script&lang=js"
export * from "./SituacionLaboralCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2fde28",
  null
  
)

export default component.exports